<template>
  <el-scrollbar wrap-class="scrollbar-wrapper">
    <el-menu
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      mode="vertical"
      background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
      :default-openeds="['/flow']"
    >
      <div class="system-name">
        <img src="@/assets/logo/logo.png" class="logo" alt="济明医药">
        <span :class="!isCollapse?'system-title':'system-title-hidden'">济明信息查询系统</span>
      </div>
      <sidebar-item
        v-for="route in permission_routers"
        :key="route.path"
        :item="route"
        :base-path="route.path"
      >
      </sidebar-item>
    </el-menu>
  </el-scrollbar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'

export default {
  components: { SidebarItem },
  computed: {
    ...mapGetters(['permission_routers', 'sidebar']),
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.system-name {
  height: 50px;
  line-height: 50px;
  text-align: center;
  vertical-align: middle;

  .logo {
    width: 20px;
    height: 20px;
    vertical-align: middle;
  }

  .system-title {
    color: #fff;
    height: 50px;
    font-size: large;
    font-weight: bold;
    vertical-align: middle;
    margin-left: 10px;
  }

  .system-title-hidden {
    visibility: hidden;
  }
}
</style>
